import BaseBreadcrumb from '../common/base-breadcrumb.vue';
export default {
  components: {
    BaseBreadcrumb
  }
};